module.exports = __webpack_public_path__ + "media/favicon/android-chrome-192x192-5b3a9595.png";